import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import groupBy from 'lodash.groupby'
import { Autocomplete } from '@material-ui/lab'
import { Paper, TextField } from '@material-ui/core'
import CommonLineBarChart from './CommonLineBarChart'
import { randomColor } from '../StatisticsPageContent'

const PerMonthPerTherapistChart = ({
  convertedData,
  getPsychologists,
  rawData,
  title,
  valueKey,
  id,
  valueFormatter,
  formatField
}) => {
  const { t } = useTranslation('statisticsPage')

  const [therapists, setTherapists] = useState([])
  const [filterData, setFilterData] = useState()

  useEffect(() => {
    setFilterData(convertedData)
  }, [convertedData])

  useEffect(() => {
    let newFilter = []
    for (const therapist of therapists) {
      const part = convertedData.filter((el) => el.naam === therapist)
      newFilter = [...newFilter, ...part]
    }
    setFilterData(newFilter)
  }, [therapists])

  const data = []
  const bars = []
  const mapData = groupBy(filterData, 'maand')

  for (const month in mapData) {
    const dataMonth = {}
    dataMonth.name = month

    for (const psychologistMonth of mapData[month]) {
      dataMonth[psychologistMonth.naam] = psychologistMonth[valueKey]

      const find = bars.find((el) => el.name === psychologistMonth.naam)
      if (!find)
        bars.push({ name: psychologistMonth.naam, color: randomColor() })
    }
    data.push(dataMonth)
  }

  const handleChange = (event, value) => {
    setTherapists(value)
  }

  const resData = {
    rawData,
    data,
    bars,
    title,
    brush: { endIndex: 1 },
    valueFormatter,
    formatField
  }

  return (
    <>
      <Paper style={{ padding: 20, marginBottom: 10 }}>
        {getPsychologists.length && (
          <Autocomplete
            onChange={handleChange}
            multiple
            id={id}
            options={getPsychologists}
            getOptionLabel={(option) => option}
            defaultValue={getPsychologists}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label={t('selectPsychologists')}
                placeholder={t('choose')}
              />
            )}
          />
        )}
        <CommonLineBarChart data={resData} />
      </Paper>
    </>
  )
}

export default PerMonthPerTherapistChart
